import { render, staticRenderFns } from "./bom_inventory.vue?vue&type=template&id=843bf234&scoped=true&"
import script from "./bom_inventory.vue?vue&type=script&lang=js&"
export * from "./bom_inventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "843bf234",
  null
  
)

export default component.exports